import { render, staticRenderFns } from "./msPagination.vue?vue&type=template&id=3568641c&scoped=true"
import script from "./msPagination.vue?vue&type=script&lang=js"
export * from "./msPagination.vue?vue&type=script&lang=js"
import style0 from "./msPagination.vue?vue&type=style&index=0&id=3568641c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3568641c",
  null
  
)

export default component.exports